import React, {useState, useEffect} from 'react';
import {object, bool} from 'prop-types';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import {APIS} from '../../../config/apis';
import {ServerRequest} from '../../../utils/apiweb';
import {Loading, DatePickerCustom, Accordion} from '../../common';
import InputNumber from '../../common/InputNumber';

const CatastroForm = (props) => {

    const entityInit = {
        id: 0,
        partida: "",
        digitoVerificador: "",
        partido: "",
        circunscripcion: "",
        seccion: "",
        chacra: "",
        letraChacra: "",
        quinta: "",
        letraQuinta: "",
        fraccion: "",
        letraFraccion: "",
        manzana: "",
        letraManzana: "",
        parcela: "",
        letraParcela: "",
        subparcela: "",
        destinatario: "",
        calle: "",
        altura: "",
        piso: "",
        departamento: "",
        barrio: "",
        entreCalle1: "",
        entreCalle2: "",
        localidad: 0,
        codigoPostal: "",
        vigencia: null,
        codigoPostalArgentina: "",
        superficie: 0,
        caracteristica: 0,
        valorTierra: 0,
        superficieEdificada: 0,
        valorEdificado: 0,
        valor1998: 0,
        valorMejoras: 0,
        edif1997: 0,
        valorFiscal: 0,
        mejoras1997: 0,
        origen: "",
        motivoMovimiento: "",
        titular: "",
        codigoTitular: "",
        dominioOrigen: "",
        dominioInscripcion: "",
        dominioTipo: "",
        dominioAnio: "",
        unidadesFuncionales: "",
        serie: "",
        cuitResponsable1: "",
        nombreYApellidoResponsable1: "",
        tipoResponsable1: "",
        cuitResponsable2: "",
        nombreYApellidoResponsable2: "",
        tipoResponsable2: "",
        catastralCodigo: ""
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
        loading: false,
        showMessage: false,
        showForm: false
    });

    const mount = () => {
        if (props.data.partida.length > 0) {
            FindCatastroPorPartida();
        } else if (props.data.circunscripcion.length > 0) {
            FindCatastroPorNomenclatura();
        } else {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Faltan datos para vincular un catastro');
        }
    }
    useEffect(mount, [props.data.partida, props.data.circunscripcion]);

    const [formValues, formHandle, , formSet] = useForm({
        partida: "",
        digitoVerificador: "",
        partido: "",
        circunscripcion: "",
        seccion: "",
        chacra: "",
        letraChacra: "",
        quinta: "",
        letraQuinta: "",
        fraccion: "",
        letraFraccion: "",
        manzana: "",
        letraManzana: "",
        parcela: "",
        letraParcela: "",
        subparcela: "",
        destinatario: "",
        calle: "",
        altura: "",
        piso: "",
        departamento: "",
        barrio: "",
        entreCalle1: "",
        entreCalle2: "",
        localidad: 0,
        codigoPostal: "",
        vigencia: null,
        codigoPostalArgentina: "",
        superficie: 0,
        caracteristica: 0,
        valorTierra: 0,
        superficieEdificada: 0,
        valorEdificado: 0,
        valor1998: 0,
        valorMejoras: 0,
        edif1997: 0,
        valorFiscal: 0,
        mejoras1997: 0,
        origen: "",
        motivoMovimiento: "",
        titular: "",
        codigoTitular: "",
        dominioOrigen: "",
        dominioInscripcion: "",
        dominioTipo: "",
        dominioAnio: "",
        unidadesFuncionales: "",
        serie: "",
        cuitResponsable1: "",
        nombreYApellidoResponsable1: "",
        tipoResponsable1: "",
        cuitResponsable2: "",
        nombreYApellidoResponsable2: "",
        tipoResponsable2: "",
        catastralCodigo: ""
    });


    // Callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessFindCatastro = (response) => {
        response.json()
            .then((data) => {

                if (data.id > 0) {
                    if (data.vigencia) data.vigencia = new Date(data.vigencia);
                    setState(prevState => {
                        return {...prevState, loading: false, showForm: true};
                    });
                    formSet({
                        ...formValues,
                        partida: data.partida,
                        digitoVerificador: data.digitoVerificador,
                        partido: data.partido,
                        circunscripcion: data.circunscripcion,
                        seccion: data.seccion,
                        chacra: data.chacra,
                        letraChacra: data.letraChacra,
                        quinta: data.quinta,
                        letraQuinta: data.letraQuinta,
                        fraccion: data.fraccion,
                        letraFraccion: data.letraFraccion,
                        manzana: data.manzana,
                        letraManzana: data.letraManzana,
                        parcela: data.parcela,
                        letraParcela: data.letraParcela,
                        subparcela: data.subparcela,
                        destinatario: data.destinatario,
                        calle: data.calle,
                        altura: data.altura,
                        piso: data.piso,
                        departamento: data.departamento,
                        barrio: data.barrio,
                        entreCalle1: data.entreCalle1,
                        entreCalle2: data.entreCalle2,
                        localidad: data.localidad,
                        codigoPostal: data.codigoPostal,
                        vigencia: data.vigencia,
                        codigoPostalArgentina: data.codigoPostalArgentina,
                        superficie: data.superficie,
                        caracteristica: data.caracteristica,
                        valorTierra: data.valorTierra,
                        superficieEdificada: data.superficieEdificada,
                        valorEdificado: data.valorEdificado,
                        valor1998: data.valor1998,
                        valorMejoras: data.valorMejoras,
                        edif1997: data.edif1997,
                        valorFiscal: data.valorFiscal,
                        mejoras1997: data.mejoras1997,
                        origen: data.origen,
                        motivoMovimiento: data.motivoMovimiento,
                        titular: data.titular,
                        codigoTitular: data.codigoTitular,
                        dominioOrigen: data.dominioOrigen,
                        dominioInscripcion: data.dominioInscripcion,
                        dominioTipo: data.dominioTipo,
                        dominioAnio: data.dominioAnio,
                        unidadesFuncionales: data.unidadesFuncionales,
                        serie: data.serie,
                        cuitResponsable1: data.cuitResponsable1,
                        nombreYApellidoResponsable1: data.nombreYApellidoResponsable1,
                        tipoResponsable1: data.tipoResponsable1,
                        cuitResponsable2: data.cuitResponsable2,
                        nombreYApellidoResponsable2: data.nombreYApellidoResponsable2,
                        tipoResponsable2: data.tipoResponsable2,
                        catastralCodigo: data.catastralCodigo,
                    });
                } else {
                    setState(prevState => {
                        return {...prevState, loading: false, showMessage: true};
                    });
                }

            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    };

    // Funciones
    function FindCatastroPorPartida() {

        setState(prevState => {
            return {...prevState, loading: true,};
        });

        const paramsUrl = `/partido/${props.data.partido}/partida/${props.data.partida}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CATASTRO,
            paramsUrl,
            null,
            callbackSuccessFindCatastro,
            callbackNoSuccess,
            callbackError
        );

    }

    function FindCatastroPorNomenclatura() {
        setState(prevState => {
            return {...prevState, loading: true};
        });

        let paramsUrl = '';

        paramsUrl = `/nomenclatura/filters?` +
            `circunscripcion=${encodeURIComponent(props.data.circunscripcion)}&` +
            `seccion=${encodeURIComponent(props.data.seccion)}&` +
            `chacra=${encodeURIComponent(props.data.chacra)}&` +
            `letraChacra=${encodeURIComponent(props.data.letraChacra)}&` +
            `quinta=${encodeURIComponent(props.data.quinta)}&` +
            `letraQuinta=${encodeURIComponent(props.data.letraQuinta)}&` +
            `fraccion=${encodeURIComponent(props.data.fraccion)}&` +
            `letraFraccion=${encodeURIComponent(props.data.letraFraccion)}&` +
            `manzana=${encodeURIComponent(props.data.manzana)}&` +
            `letraManzana=${encodeURIComponent(props.data.letraManzana)}&` +
            `parcela=${encodeURIComponent(props.data.parcela)}&` +
            `letraParcela=${encodeURIComponent(props.data.letraParcela)}&` +
            `subparcela=${encodeURIComponent(props.data.subparcela)}&` +
            `catastralCodigo=${encodeURIComponent(props.data.catastralCodigo)}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CATASTRO,
            paramsUrl,
            null,
            callbackSuccessFindCatastro,
            callbackNoSuccess,
            callbackError
        );
    }

    return (
        <>
            <Loading visible={state.loading}></Loading>

            {state.showMessage &&
                <div className="body">
                    <div className="row">

                        <div className="col-12">
                            <h3 className="form-label">No existe ningún registro asociado a la nomenclatura catastral
                                ingresada.</h3>
                        </div>

                    </div>
                </div>
            }

            {state.showForm &&
                <div className="body">
                    <div className="row">
                        <div className="mb-3 col-4 col-lg-2">
                            <label htmlFor="partida" className="form-label">Partida</label>
                            <input
                                name="partida"
                                type="text"
                                placeholder=""
                                className="form-control"
                                value={formValues.partida}
                                onChange={formHandle}
                                disabled={props.disabled}
                            />
                        </div>
                        <div className="mb-3 col-4 col-lg-2">
                            <label htmlFor="digitoVerificador" className="form-label">Dígito verificador</label>
                            <input
                                name="digitoVerificador"
                                type="text"
                                placeholder=""
                                className="form-control"
                                value={formValues.digitoVerificador}
                                onChange={formHandle}
                                disabled={props.disabled}
                            />
                        </div>

                        <div className="mb-3 col-12">
                            <Accordion title="Nomenclatura catastral" startOpen={true}>
                                <div className='row form-basic'>
                                    <div className="mb-3 col-4 col-lg-2">
                                        <label htmlFor="partido" className="form-label">Partido</label>
                                        <input
                                            name="partido"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.partido}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-4 col-lg-2">
                                        <label htmlFor="circunscripcion"
                                               className="form-label">Circunscripción</label>
                                        <input
                                            name="circunscripcion"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.circunscripcion}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-4 col-lg-2">
                                        <label htmlFor="seccion" className="form-label">Sección</label>
                                        <input
                                            name="seccion"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.seccion}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-4 col-lg-2">
                                        <label htmlFor="catastralCodigo" className="form-label">Código</label>
                                        <input
                                            name="catastralCodigo"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.catastralCodigo}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-4 col-lg-2">
                                        <label htmlFor="chacra" className="form-label">Chacra</label>
                                        <input
                                            name="chacra"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.chacra}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-4 col-lg-2">
                                        <label htmlFor="letraChacra" className="form-label">Letra chacra</label>
                                        <input
                                            name="letraChacra"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.letraChacra}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-4 col-lg-2">
                                        <label htmlFor="quinta" className="form-label">Quinta</label>
                                        <input
                                            name="quinta"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.quinta}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-4 col-lg-2">
                                        <label htmlFor="letraQuinta" className="form-label">Letra quinta</label>
                                        <input
                                            name="letraQuinta"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.letraQuinta}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-4 col-lg-2">
                                        <label htmlFor="fraccion" className="form-label">Fracción</label>
                                        <input
                                            name="fraccion"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.fraccion}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-4 col-lg-2">
                                        <label htmlFor="letraFraccion" className="form-label">Letra fracción</label>
                                        <input
                                            name="letraFraccion"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.letraFraccion}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-4 col-lg-2">
                                        <label htmlFor="manzana" className="form-label">Manzana</label>
                                        <input
                                            name="manzana"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.manzana}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-4 col-lg-2">
                                        <label htmlFor="letraManzana" className="form-label">Letra manzana</label>
                                        <input
                                            name="letraManzana"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.letraManzana}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-4 col-lg-2">
                                        <label htmlFor="parcela" className="form-label">Parcela</label>
                                        <input
                                            name="parcela"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.parcela}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-4 col-lg-2">
                                        <label htmlFor="letraParcela" className="form-label">Letra parcela</label>
                                        <input
                                            name="letraParcela"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.letraParcela}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-4 col-lg-2">
                                        <label htmlFor="subparcela" className="form-label">Sub parcela</label>
                                        <input
                                            name="subparcela"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.subparcela}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-4 col-lg-2">
                                        <label htmlFor="unidadesFuncionales" className="form-label">Unidades
                                            funcionales</label>
                                        <input
                                            name="unidadesFuncionales"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.unidadesFuncionales}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                </div>
                            </Accordion>
                        </div>
                    </div>
                    <div className="mb-3 col-12">
                        <Accordion title="Información de responsables">
                            <div className='row form-basic'>
                                <div className="mb-3 col-4 col-lg-3">
                                    <label htmlFor="cuitResponsable1" className="form-label">CUIT Responsable
                                        1</label>
                                    <input
                                        name="cuitResponsable1"
                                        type="text"
                                        placeholder=""
                                        className="form-control"
                                        value={formValues.cuitResponsable1}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                </div>
                                <div className="mb-3 col-4 col-lg-6">
                                    <label htmlFor="nombreYApellidoResponsable1" className="form-label">Nombre y
                                        Apellido Responsable 1</label>
                                    <input
                                        name="nombreYApellidoResponsable1"
                                        type="text"
                                        placeholder=""
                                        className="form-control"
                                        value={formValues.nombreYApellidoResponsable1}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                </div>
                                <div className="mb-3 col-4 col-lg-3">
                                    <label htmlFor="tipoResponsable1" className="form-label">Tipo Responsable
                                        1</label>
                                    <input
                                        name="tipoResponsable1"
                                        type="text"
                                        placeholder=""
                                        className="form-control"
                                        value={formValues.tipoResponsable1}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                </div>
                                <div className="mb-3 col-4 col-lg-3">
                                    <label htmlFor="cuitResponsable2" className="form-label">CUIT Responsable
                                        2</label>
                                    <input
                                        name="cuitResponsable2"
                                        type="text"
                                        placeholder=""
                                        className="form-control"
                                        value={formValues.cuitResponsable2}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                </div>
                                <div className="mb-3 col-4 col-lg-6">
                                    <label htmlFor="nombreYApellidoResponsable2" className="form-label">Nombre y
                                        Apellido Responsable 2</label>
                                    <input
                                        name="nombreYApellidoResponsable2"
                                        type="text"
                                        placeholder=""
                                        className="form-control"
                                        value={formValues.nombreYApellidoResponsable2}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                </div>
                                <div className="mb-3 col-4 col-lg-3">
                                    <label htmlFor="tipoResponsable2" className="form-label">Tipo Responsable
                                        2</label>
                                    <input
                                        name="tipoResponsable2"
                                        type="text"
                                        placeholder=""
                                        className="form-control"
                                        value={formValues.tipoResponsable2}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                </div>
                            </div>
                        </Accordion>
                    </div>
                    <div className="row">
                        <div className="mb-3 col-12">
                            <Accordion title="Información de dominio">
                                <div className='row form-basic'>
                                    <div className="mb-3 col-6 col-lg-6">
                                        <label htmlFor="destinatario" className="form-label">Destinatario</label>
                                        <input
                                            name="destinatario"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.destinatario}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-6">
                                        <label htmlFor="titular" className="form-label">Titular</label>
                                        <input
                                            name="titular"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.titular}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="codigoTitular" className="form-label">Código titular</label>
                                        <input
                                            name="codigoTitular"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.codigoTitular}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="vigencia" className="form-label">Vigencia</label>
                                        <DatePickerCustom
                                            name="vigencia"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.vigencia}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="origen" className="form-label">Origen</label>
                                        <input
                                            name="origen"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.origen}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="motivoMovimiento" className="form-label">Motivo
                                            movimiento</label>
                                        <input
                                            name="motivoMovimiento"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.motivoMovimiento}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="dominioOrigen" className="form-label">Dominio origen</label>
                                        <input
                                            name="dominioOrigen"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.dominioOrigen}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="dominioInscripcion" className="form-label">Dominio
                                            inscripción</label>
                                        <input
                                            name="dominioInscripcion"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.dominioInscripcion}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="dominioTipo" className="form-label">Dominio tipo</label>
                                        <input
                                            name="dominioTipo"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.dominioTipo}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="dominioAnio" className="form-label">Dominio año</label>
                                        <input
                                            name="dominioAnio"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.dominioAnio}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="serie" className="form-label">Serie</label>
                                        <input
                                            name="serie"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.serie}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                </div>
                            </Accordion>
                        </div>
                        <div className="mb-3 col-12">
                            <Accordion title="Información edilicia">
                                <div className='row form-basic'>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="caracteristica"
                                               className="form-label">Característica</label>
                                        <input
                                            name="caracteristica"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.caracteristica}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="superficie" className="form-label">Superficie</label>
                                        <InputNumber
                                            name="superficie"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.superficie}
                                            precision={2}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="superficieEdificada" className="form-label">Superficie
                                            edificada</label>
                                        <InputNumber
                                            name="superficieEdificada"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.superficieEdificada}
                                            precision={2}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="valorEdificado" className="form-label">Valor
                                            edificado</label>
                                        <InputNumber
                                            name="valorEdificado"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.valorEdificado}
                                            precision={2}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="valorTierra" className="form-label">Valor tierra</label>
                                        <InputNumber
                                            name="valorTierra"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.valorTierra}
                                            precision={2}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="valorFiscal" className="form-label">Valor fiscal</label>
                                        <InputNumber
                                            name="valorFiscal"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.valorFiscal}
                                            precision={2}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="valorMejoras" className="form-label">Valor mejoras</label>
                                        <InputNumber
                                            name="valorMejoras"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.valorMejoras}
                                            precision={2}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="valor1998" className="form-label">Valor 1998</label>
                                        <InputNumber
                                            name="valor1998"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.valor1998}
                                            precision={2}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="edif1997" className="form-label">Edif. 1997</label>
                                        <InputNumber
                                            name="edif1997"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.edif1997}
                                            precision={2}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="mejoras1997" className="form-label">Mejoras 1997</label>
                                        <InputNumber
                                            name="mejoras1997"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.mejoras1997}
                                            precision={2}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                </div>
                            </Accordion>
                        </div>
                        <div className="mb-3 col-12">
                            <Accordion title="Domicilio">
                                <div className='row form-basic'>
                                    <div className="mb-3 col-6 col-lg-6">
                                        <label htmlFor="calle" className="form-label">Calle</label>
                                        <input
                                            name="calle"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.calle}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-6">
                                        <label htmlFor="barrio" className="form-label">Barrio</label>
                                        <input
                                            name="barrio"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.barrio}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-6">
                                        <label htmlFor="entreCalle1" className="form-label">Entre calle (1)</label>
                                        <input
                                            name="entreCalle1"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.entreCalle1}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-6">
                                        <label htmlFor="entreCalle2" className="form-label">Entre calle (2)</label>
                                        <input
                                            name="entreCalle2"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.entreCalle2}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-2">
                                        <label htmlFor="altura" className="form-label">Altura</label>
                                        <input
                                            name="altura"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.altura}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-2">
                                        <label htmlFor="piso" className="form-label">Piso</label>
                                        <input
                                            name="piso"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.piso}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-2">
                                        <label htmlFor="departamento" className="form-label">Departamento</label>
                                        <input
                                            name="departamento"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.departamento}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="codigoPostal" className="form-label">Código postal</label>
                                        <input
                                            name="codigoPostal"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.codigoPostal}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-3">
                                        <label htmlFor="codigoPostalArgentina" className="form-label">CPA</label>
                                        <input
                                            name="codigoPostalArgentina"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.codigoPostalArgentina}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                    <div className="mb-3 col-6 col-lg-6">
                                        <label htmlFor="localidad" className="form-label">Localidad</label>
                                        <input
                                            name="localidad"
                                            type="text"
                                            placeholder=""
                                            className="form-control"
                                            value={formValues.localidad}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </div>
                                </div>
                            </Accordion>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

CatastroForm.propTypes = {
    disabled: bool,
    data: object.isRequired,
};

CatastroForm.defaultProps = {
    disabled: false
};

export default CatastroForm;
